module.exports = __webpack_public_path__ + "img/selected6-min.7cb2dec5.png";